export default "__VITE_ASSET__1dfb8de1__"